import { useEffect, useState } from 'react'

import { useAppDispatch, useAppSelector } from 'app/hooks'
import { useDebounceState } from 'app/hooks/useDebounceState'
import { FetchErrors } from 'app/redux-fetch'

import { selectedHomeSelector } from 'features/home/selectors'
import { fetchCloudSoftwareHistoryThunk } from '../HomeSoftware/HomeCloudSoftwareHistory/slice'
import { fetchHomeActiveConfigThunk } from './slice'

const SIX_SECONDS = 6000

export const usePollForHomeConfigUpdates = () => {
  const selectedHome = useAppSelector(selectedHomeSelector.data)

  const dispatch = useAppDispatch()
  const [poll, setPoll] = useState(false)

  useDebounceState(poll, setPoll, SIX_SECONDS)

  function pollForEachUpdate() {
    if (!selectedHome || !selectedHome.id) {
      return
    }

    if (!poll) {
      dispatch(
        fetchCloudSoftwareHistoryThunk({
          homeId: selectedHome.id,
          partNumber: selectedHome.hostType,
        })
      )
      dispatch(
        fetchHomeActiveConfigThunk(selectedHome.id, {
          type: 'config',
          lastactive: true,
        })
      )
      setPoll(true)
    }
    return
  }

  useEffect(pollForEachUpdate, [dispatch, poll, selectedHome])

  return
}

export const extractDeployErrorMessage = (deployError: FetchErrors) =>
  deployError?.length > 0 ? deployError[0].detail : null
